import { theme } from '@zappyrent/hundop';
import React from 'react';

import { StyledImage, StyledImageWrapper } from './ReferALandlordIntro.styles';

const ReferALandlordIntroImage = (): JSX.Element => {
  return (
    <StyledImageWrapper>
      <StyledImage
        alt="Zappyrent"
        src={`${process.env.GATSBY_CDN_URL}/refer-a-landlord/refer-a-landlord-1024.jpg`}
        sizes={`
          (max-width: calc(${theme.breakpoints.l} - 1px)) 100vw,
          50vw
        `}
        srcSet={`
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/refer-a-landlord-496.jpg 496w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/refer-a-landlord-768.jpg 768w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/refer-a-landlord-992.jpg 992w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/refer-a-landlord-1024.jpg 1024w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/refer-a-landlord-1536.jpg 1536w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/refer-a-landlord-2048.jpg 2048w,
        `}
      />
    </StyledImageWrapper>
  );
};

export default ReferALandlordIntroImage;
